<template>
  <div>
    <v-dialog v-model="dialog_open" max-width="700" persistent>
      <v-card>
        <v-card-title class="py-0">
          <v-col cols="10" sm="11">
            <span
              class="ml-3 font-weight-bold "
              style="font-size: 24px; color: #000000; font-family: 'Sarabun', sans-serif;"
            >
              ใบรับรองแพทย์
            </span>
          </v-col>
          <v-col cols="2" sm="1">
            <v-btn icon @click="closeDialog()" style="text-align:right;">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span
              style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
            >
              ข้อมูลแพทย์
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span
                    style="font-size: 16px;"
                  >
                    สถานที่ตรวจ
                  </span>
                  <v-text-field
                    v-model="payload.biz.biz_name"
                    hide-details
                    outlined
                    dense
                    disabled
                    class="mt-1"
                    style="background-color: #E8E9E9;"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span
                    style="font-size: 16px;"
                  >
                    แพทย์ <span style="color: red;">*</span>
                  </span>
                  <v-combobox
                    attach
                    v-model="select_doc"
                    placeholder="ชื่อแพทย์"
                    :item="searchDoc"
                    outlined
                    dense
                    hide-details
                    :items="searchDoc"
                    @input="searchDoctor"
                    item-text="name_th"
                    return-object
                    class="mt-1"
                    :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    :disabled="isApprove"
                    :style="isApprove ? 'background-color: #E8E9E9;' : ''"
                    color="#00A99D"
                  >
                    <template v-slot:append>
                      <img src="../../assets/icon/medcert/search.svg" alt="search">
                    </template>
                  </v-combobox>
                </v-col>

                <v-col cols="6">
                  <span
                    style="font-size: 16px;"
                  >
                    ใบอนุญาตเลขที่
                  </span>
                  <v-text-field
                    v-model="payload.doctor.doctor_license"
                    placeholder="ใบอนุญาตเลขที่"
                    hide-details
                    outlined
                    dense
                    class="mt-1"
                    disabled
                    style="background-color: #E8E9E9;"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span
                    style="font-size: 16px;"
                  >
                    สถานที่ประกอบวิชาชีพเวชกรรม
                  </span>
                  <v-text-field
                    v-model="payload.biz.biz_address"
                    hide-details
                    outlined
                    dense
                    disabled
                    class="mt-1"
                    style="background-color: #E8E9E9;"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span
              style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
            >
              ข้อมูลผู้ป่วย
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <span
                    style="font-size: 16px;"
                  >
                    ชื่อ-นามสกุลผู้ป่วย
                  </span>
                  <v-text-field
                    v-model="payload.patient.patient_name"
                    hide-details
                    outlined
                    dense
                    disabled
                    class="mt-1"
                    style="background-color: #E8E9E9;"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <span
                    style="font-size: 16px;"
                  >
                    เลขประจำตัวประชาชน
                  </span>
                  <v-text-field
                    v-model="show_patient_cid"
                    hide-details
                    outlined
                    dense
                    disabled
                    class="mt-1"
                    style="background-color: #E8E9E9;"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span
                    style="font-size: 16px;"
                  >
                    ที่อยู่ที่สามารถติดต่อได้
                  </span>
                  <v-text-field
                    v-model="display_address"
                    hide-details
                    outlined
                    dense
                    disabled
                    class="mt-1"
                    style="background-color: #E8E9E9;"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span
              style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
            >
              ข้อมูลการตรวจ
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>
        <v-card-text class="py-0">
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span
                    style="font-size: 16px;"
                  >
                    วันที่รับการตรวจ
                  </span>
                  <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    :return-value.sync="health_check_date"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_format"
                        persistent-hint
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        outlined
                        dense
                        class="mt-1"
                        hide-details=""
                        :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                        :disabled="isApprove"
                        :style="isApprove ? 'background-color: #E8E9E9;' : ''"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="payload.health_check_date"
                      no-title
                      :max="today"
                      color="#00A99D"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#F5222D"
                        @click="menu2 = false"
                        outlined
                      >
                        ยกเลิก
                      </v-btn>
                      <v-btn
                        solo
                        color="#00A99D"
                        style="color: white;"
                        @click="$refs.menu.save(saveDate(payload.health_check_date))"
                      >
                        ตกลง
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <div class="d-flex">
                    <v-checkbox
                      v-model="enabled_other"
                      hide-details
                      class="shrink mt-0 mb-1"
                      color="#00A99D"
                    ></v-checkbox>
                    <span
                      class="mt-1"
                      style="font-size: 16px;"
                    >
                      โรคอื่น ๆ
                    </span>
                  </div>
                  <v-text-field
                    v-model="payload.other"
                    placeholder="ถ้ามีโปรดระบุ"
                    color="#00A99D"
                    outlined
                    dense
                    hide-details
                    :disabled="!enabled_other"
                    :style="enabled_other ? '' : 'background-color: #E8E9E9;'"
                    class="mt-1"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <span
                    style="font-size: 16px;"
                  >
                    ความเห็นและข้อแนะนำ
                  </span>
                  <v-textarea
                    auto-grow
                    hide-details
                    rows="4"
                    row-height="30"
                    color="#00A99D"
                    outlined
                    v-model="payload.summary"
                    class="mt-1"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text>

        <!-- <v-card-title class="py-0">
          <v-col cols="12" class="pb-0">
            <span
              style="font-size: 18px; color: #1A1C1D; font-family: 'Sarabun', sans-serif;"
            >
              ชื่อเจ้าหน้าที่ผู้ออกใบรับรอง
            </span>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-title>

        <v-card-text class="py-0">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span
                    style="font-size: 16px;"
                  >
                    ชื่อเจ้าหน้าที่ผู้ออกใบรับรอง <span style="color: red;">*</span>
                  </span>
                  <v-combobox
                    attach
                    placeholder="ชื่อเจ้าหน้าที่ผู้ออกใบรับรอง"
                    v-model="select_doc"
                    outlined
                    dense
                    hide-details
                    :items="searchDoc"
                    @input="searchDoctor"
                    item-text="name_th"
                    return-object
                    class="mt-1"
                    :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    :disabled="isApprove"
                    :style="isApprove ? 'background-color: #E8E9E9;' : ''"
                    color="#00A99D"
                  >
                    <template v-slot:append>
                      <img src="../../assets/icon/medcert/search.svg" alt="search">
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-container>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-card-text> -->

        <v-card-text class="py-0">
          <v-row align="center" class="px-8 mt-5">
            <v-col cols="6" align="end">
              <v-btn
                @click="closeDialog()"
                style="width: 100%;"
                outlined
                color="#00a99d"
                dark
                class="card-medium-cancel"
              >
                <span style="color: #00a99d;" class="font-14">ยกเลิก</span>
              </v-btn>
            </v-col>
            <v-col cols="6" align="start">
              <v-btn
                class="card-medium"
                style="width: 100%;"
                depressed
                color="#00a99d"
                :disabled="disabled_btn"
                :loading="loading_btn"
                @click="btn_name == 'อนุมัติเอกสาร' ? approveDoc() : requestDoc()"
              >
                <span style="color: #FFFFFF;" class="font-14"
                  >{{ btn_name }}</span
                >
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ApproveDoc ref="approveDoc"/>
  </div>
</template>

<script>
import moment from 'moment'

import ApproveDoc from '@/components/dialog/ApproveDialog.vue'
import { EventBus } from "@/EventBus"
import functioncryto from "@/services/encrypt.js";

export default {
  components: {
    ApproveDoc
  },
  data: () => ({
    loading_btn: false,
    dialog_open: false,

    payload: {
      //biz
      biz: {
        biz_address: "",
        biz_id: "",
        biz_name: "",
      },
      //doctor
      doctor: {
        biz_id: "",
        doctor_license: "",
        doctor_name: "",
        one_id: ""
      },
      //patient
      patient: {
        biz_id:"",
        one_id: "",
        patient_address: {},
        patient_id_card_number: "",
        patient_name: "",
      },
    },
    show_patient_cid: "",

    select_doc: {
      name_th: "เลือกแพทย์"
    },

    display_address: "",

    //ข้อมูลการตรวจ
    health_check_date: "",
    request_date: "",
    enabled_other: false,
    other: "",
    summary: "",

    doc_code: "",
    doc_name: "",

    _id: "",

    menu2: "",
    today: moment().format("YYYY-MM-DD"),
    btn_name: "",
    date_format: "วัน/เดือน/ปี",
    searchDoc: [],
    isApprove: false,
    cid: "",

    rules: {
      required: v => !!v || 'กรุณากรอกข้อมูล',
    },

    mode: "",
    patient_id:"",
    status_display_address:false
  }),
  watch: {
    enabled_other (val) {
      if (!val) {
        this.payload.other = ""
      }
    }
    // select_doc (val) {
    //   // console.log(val)
    //   if (val) {
    //     this.payload.doctor = {
    //       biz_id: val.biz_id,
    //       doctor_license: val.doctor_license,
    //       doctor_name: val.name_th,
    //       one_id: val.one_id
    //     }
    //   }
    // }
  },
  async mounted () {

  },
  computed: {
    disabled_btn () {
      if (
        this.date_format == 'วัน/เดือน/ปี' ||
        !this.select_doc ||
        this.select_doc.name_th === 'เลือกแพทย์'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async open (input) {
      // console.log(input)
      this.select_doc = {
        name_th: "เลือกแพทย์"
      }
      this.patient_id = input.patient_id
      this.payload = input.item
      this.health_check_date = input.item.health_check_date
      this.request_date = input.item.request_date
      if (input.item.other) {
        this.enabled_other = true
      }
      this.mode = input.mode
      this.btn_name = "ออกเอกสาร"

      let address = ""
      // if (input.mode == 'input') {
      //   this.payload.patient.patient_address = this.payload.patient.patient_address[0]
      // }

      if (Array.isArray(this.payload.patient.patient_address)){
        if (this.payload.patient.patient_address.length > 0){
          const index_address = this.payload.patient.patient_address.length - 1
          for (const key of Object.entries(this.payload.patient.patient_address[index_address])) {
            if (key[1] && key[1] != 'null') {
              if (key[0] == "houseNo") {
                address = address + "บ้านเลขที่ " + key[1] + " "
              } else if (key[0] == "moo") {
                address = address + "หมู่ที่ " + key[1] + " "
              } else if (key[0] == "soi") {
                address = address + "ซอย " + key[1] + " "
              } else if (key[0] == "amphur") {
                address = address + "อำเภอ/เขต " + key[1] + " "
              } else if (key[0] == "tambon") {
                address = address + "ตำบล/แขวง " + key[1] + " "
              } else if (key[0] == "province") {
                address = address + "จังหวัด " + key[1] + " "
              } else if (key[0] == "zipcode") {
                address = address + "รหัสไปรษณีย์ " + key[1] + " "
              }
            }
          }
          this.display_address = address
        }
      } else {
        this.display_address = this.payload.patient.patient_address
      }
      if (this.display_address){
        this.status_display_address = true
      }

      // console.log("addr", address)

      this.show_patient_cid = functioncryto.decrypt(this.payload.patient.patient_id_card_number)

      this.date_format = moment(input.item.health_check_date).add(543, "year").locale("th").format("DD MMMM YYYY")
      // console.log(`>>>>>> `, input)
      // this.request_date = input.request_date

      this.doc_code = input.doc_code
      this.doc_name = input.doc_name

      // console.log("doc_code", this.doc_code)
      // console.log("doc_name", this.doc_name)

      if (input.mode == "approve") {
        this._id = input._id
        this.isApprove = true
        this.btn_name = "อนุมัติเอกสาร"
      }
      await this.getStaff()
      this.dialog_open = true
      setTimeout(() => {
        document.getElementsByClassName('v-dialog--active')[0].scrollTop = 0
      }, 100)
    },
    closeDialog () {
      this.dialog_open = false
    },
    formatDate (date) {
      return moment(date).add(543, "year").locale("th").format("DD MMMM YYYY")
    },
    async approveDoc () {
      // console.log("approve", this.payload)
      // console.log("id", this._id)
      try {
        let params = new URLSearchParams()
        params.append("id", this._id)
        params.append("doc_type", this.doc_code)
        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/updateTransaction?${params}`,
          {
            other: this.payload.other || "",
            summary: this.payload.summary || ""
          }
        ).then((res) => {
          // console.log("=>", res)
          if (res.data.result === "success") {
            this.creatPdf()
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async creatPdf () {
      // console.log(this.select_doc)
      this.loading_btn = true
      this.payload.patient.patient_address = this.display_address
      this.payload.patient.patient_id_card_number = functioncryto.decrypt(this.payload.patient.patient_id_card_number)
      await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign/create-med-cert`,
      // await this.axios.post(`http://localhost:5000/v1/sign/create-med-cert`,
        {
          payload: this.payload,
          sign_position: 2.2,
          doc_code: this.doc_code,
          doc_name: this.doc_name,
          pageToSign: 1,
          biz_id: sessionStorage.biz_id,
          request_date: this.request_date,
          health_check_date: this.health_check_date,
          file_id: "",
          status: "request"
          // payload: {
          // },
        }
      ).then((res) => {
        // console.log(res)
        if (res.data.result == "success") {
          let item = {
            id: this._id,
            doc_code: this.doc_code,
            pdf_data: res.data.data,
            doctor_name: this.payload.doctor.doctor_name,
            cid: functioncryto.encrypt(this.payload.patient.patient_id_card_number),
            payload_success:res.data.payload
          }

          if (this.doc_code == "MEDICAL_CERTIFICATE") {
            this.$refs.approveDoc.open(item)
          }
        }

        this.loading_btn = false
        this.closeDialog()
      })
      .catch((err) => {
        this.loading_btn = false
        console.log('err:', err.message)
      })
    },
    saveDate (date) {
      this.date_format = moment(date).add(543, "year").locale("th").format("DD MMMM YYYY")
      return moment(date).locale("th").format("YYYY-MM-DD")
    },
    async requestDoc () {
      this.$swal.fire({
        title: `<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>หากคุณต้องการขอ ${this.doc_name} ของ "${this.payload.patient.patient_name}"<br/>กรุณากดยืนยันเพื่อดำเนินการต่อ</span>`,
        showCancelButton: true,
        cancelButtonText: "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยกเลิก</span>",
        confirmButtonText: "<span style='font-size: 14px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        cancelButtonColor: "#F5222D",
        reverseButtons: true,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.confirmDoc()
        }
      })
    },
    async confirmDoc () {
      try {
        // console.log("doc", this.select_doc)
        let params = new URLSearchParams()
        params.append("doc_type", this.doc_code)
        await this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/addTransaction?${params}`,
        {
          payload: this.payload,
          doc_code: this.doc_code,
          doc_name: this.doc_name,
          create_by: sessionStorage.getItem("role_name") ,
          patient_id:this.patient_id
        }).then((res) => {
          // console.log(res)
          this.dialog_open = false
          if (res.data.result === 'success') {
            this.$swal.fire({
              icon: "success",
              title: `<span style="font-size: 20px;">ขอเอกสารสำเร็จ</span>`,
              showConfirmButton: false,
              timer: 2000,
            })
            EventBus.$emit('getData')
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async getStaff () {
      try {
        let params = new URLSearchParams()
        params.append("biz_id", sessionStorage.biz_id)
        params.append("mode", "all-doctor")
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/getStaff?${params}`).then((res) => {
          // console.log(">>> res", res, " ---------------")

          if (this.mode == "input") {
            if (sessionStorage.role_name == "แพทย์") {
              for (let i in res.data.data) {
                if (res.data.data[i].one_id == sessionStorage.oneId) {
                  this.select_doc = res.data.data[i];
                }
              }
            }
          } else if (this.mode == "approve") {
            this.select_doc = {
              biz_id: this.payload.doctor.biz_id,
              doctor_license: this.payload.doctor.doctor_license,
              name_th:  this.payload.doctor.doctor_name,
              one_id: this.payload.doctor.one_id
            }
          }

          this.searchDoc = res.data.data
        })
      } catch (err) {
        console.log(err)
      }
    },
    searchDoctor () {
      if (this.select_doc) {
        this.payload.doctor = {
          biz_id: this.select_doc.biz_id,
          doctor_license: this.select_doc.doctor_license,
          doctor_name: this.select_doc.name_th,
          one_id: this.select_doc.one_id
        }
      }
    }
  }
}
</script>

<style scoped>
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot > .v-select__slot > input {
  line-height: 1.7rem;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  line-height: 1.7rem;
}
</style>
